import * as Scrivito from "scrivito";

function PlainTableCellWidgetComponent({
  widget,
  header,
  alignment = "top",
  asHeader = false,
}) {
  return (
    <Scrivito.ContentTag
      tag={asHeader ? "th" : "td"}
      content={widget}
      attribute="cell"
      data-th={header}
      className={`table-cell --alignment-${alignment}`}
      scope={asHeader ? "row" : undefined}
    />
  );
}

const TableCellWidgetComponent = Scrivito.connect(
  PlainTableCellWidgetComponent
);

export default TableCellWidgetComponent;
